import React from 'react';
import 'antd/dist/antd.css';
import { Rate, Progress } from 'antd';
import { Div, HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { IRate } from 'types/types';
import { TextDisplay } from 'vendor-deprecated/Text';
import { AppColors } from 'helpers';
import { useTranslationText } from 'locale';
import styled from 'styled-components';
import { Hr } from 'vendor-deprecated/CommonParts';
import { useAppSetting } from 'helpers/useAppSetting';
import { AnimationView } from 'vendor-deprecated/Animation';

const RateWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  .ant-rate {
    width: 100px;
  }
  .ant-rate-star.ant-rate-star-full,
  .ant-rate-star.ant-rate-star-zero,
  .ant-rate-star.ant-rate-star-half.ant-rate-star-active {
    width: 12px;
    height: 12px;
  }

  .ant-rate-star.ant-rate-star-half.ant-rate-star-active:hover {
    transform: scale(0.91);
    width: 12px;
    height: 12px;
  }

  .ant-rate-star.ant-rate-star-full:hover {
    width: 12px;
    height: 12px;
  }

  .ant-rate-star.ant-rate-star-zero:hover {
    width: 12px;
    height: 12px;
  }
`;

type RateBarProps = {
  value: number;
  roundHalf?: boolean;
  disabled?: boolean;
  onChange?: (value: number) => void;
};

function roundHalf(num: number) {
  return Math.round(num * 2) / 2;
}

export const RateBar = (props: RateBarProps) => {
  const [load, setLoaded] = React.useState(false);
  React.useEffect(() => {
    const t = setTimeout(() => {
      setLoaded(true);
    }, 300);
    return () => clearTimeout(t);
  }, []);
  return (
    <Div width={'100px'} opacity={load ? 1 : 0} overflow={'hidden'}>
      <AnimationView width={'100%'} duration={load ? 300 : 0} animation={load ? 'fadeIn' : 'fadeOut'}>
        <RateWrapper>
          <Rate
            style={{ color: AppColors.ORANGE }}
            allowHalf={props.roundHalf}
            disabled={props.disabled}
            value={props.roundHalf ? roundHalf(props.value) : props.value}
            onChange={props.onChange}
          />
        </RateWrapper>
      </AnimationView>
    </Div>
  );
};

type RateComponentProps = {
  avgRate: number;
  totalReviews: number;
  rates: IRate[];
};

export const RateComponent = (props: RateComponentProps) => {
  const [isMounted, setMounted] = React.useState(false);
  const { translation } = useTranslationText();
  const { appLayout } = useAppSetting();

  React.useEffect(() => {
    const t = setTimeout(() => {
      setMounted(true);
    }, 300);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimationView width={'100%'} duration={isMounted ? 300 : 0} animation={isMounted ? 'fadeIn' : 'fadeOut'}>
      <VerticalView
        fullWidth
        alignContent={'centerLeft'}
        padding={'15px'}
        border={`1px solid ${AppColors.BORDER}`}
        borderRadius={'4px'}
        background={AppColors.BACKGROUND_REVIEW}
      >
        <TextDisplay size={'20px'} fontWeight={700} color={AppColors.BLACK} marginBottom={'10px'}>
          {translation('studentRate')}
        </TextDisplay>
        <Hr />
        <HorizontalView fullWidth alignContent={'centerLeft'}>
          {appLayout.isMobile && (
            <HorizontalView>
              <TextDisplay size={'40px'} fontWeight={700} color={AppColors.BLACK} marginRight={'10px'}>
                {props.avgRate.toFixed(1)}
              </TextDisplay>
              <RateBar roundHalf disabled value={props.avgRate} />
              <TextDisplay size={'13px'} color={AppColors.DARK} marginLeft={'10px'} marginTop={'5px'} fontWeight={500}>
                {props.totalReviews} {translation('rating')}
              </TextDisplay>
            </HorizontalView>
          )}

          {!appLayout.isMobile && (
            <VerticalView width={'130px'}>
              <TextDisplay size={'40px'} fontWeight={700} color={AppColors.BLACK}>
                {props.avgRate.toFixed(1)}
              </TextDisplay>
              <RateBar roundHalf disabled value={props.avgRate} />
              <TextDisplay size={'13px'} color={AppColors.DARK} marginTop={'5px'} fontWeight={500}>
                {props.totalReviews} {translation('rating')}
              </TextDisplay>
            </VerticalView>
          )}

          <VerticalView width={appLayout.isMobile ? '100%' : 'calc(100% - 130px)'} height={'170px'} overflow={'hidden'}>
            {props.rates.map((rate, index) => {
              return (
                <HorizontalView
                  fullWidth
                  key={index}
                  paddingTop={'5px'}
                  flexWrap={'nowrap'}
                  alignContent={'centerLeft'}
                >
                  <Div width={'calc(100% - 140px)'}>
                    <Progress
                      strokeWidth={15}
                      strokeColor={{
                        '0%': '#108ee9',
                        '100%': '#87d068',
                      }}
                      status={'normal'}
                      percent={rate.percent ? parseInt((rate.percent * 100).toFixed(0)) : 0}
                      size={'default'}
                      format={() => {
                        return (
                          <Div width={'160px'}>
                            <Div width={'100px'}>
                              <RateBar disabled value={rate.value!} />
                            </Div>
                            <Div width={'50px'}>{rate.percent ? (rate.percent * 100).toFixed(0) : '0'}%</Div>
                          </Div>
                        );
                      }}
                    />
                  </Div>
                </HorizontalView>
              );
            })}
          </VerticalView>
        </HorizontalView>
      </VerticalView>
    </AnimationView>
  );
};
